export const DEFAULT_APP_SUBDOMAIN = "r"
export const DEFAULT_RESERVED_SUBDOMAINS = ["r", "www", "api", "admin", "app"]
export const CUSTOM_TENANT_HOSTS: Record<string, string> = {
	"calumpit.helti.store": "calumpit",
}

export const normalizeHost = (value: unknown) => {
	const host = String(value || "")
		.split(",")[0]
		.trim()
		.toLowerCase()

	if (!host) return ""

	return host.split(":")[0]
}

export const normalizeAppSubdomain = (value: unknown) => {
	const subdomain = String(value || "")
		.trim()
		.toLowerCase()

	return subdomain || DEFAULT_APP_SUBDOMAIN
}

export const parseReservedSubdomains = (value: unknown) => {
	const raw = String(value || "")
		.split(",")
		.map((item) => item.trim().toLowerCase())
		.filter(Boolean)

	if (!raw.length) return DEFAULT_RESERVED_SUBDOMAINS

	return Array.from(new Set([...DEFAULT_RESERVED_SUBDOMAINS, ...raw]))
}

export const getReservedSubdomains = (options?: {
	appSubdomain?: unknown
	reservedSubdomains?: unknown
}) => {
	const appSubdomain = normalizeAppSubdomain(options?.appSubdomain)
	const reserved = parseReservedSubdomains(options?.reservedSubdomains)

	return Array.from(new Set([...reserved, appSubdomain]))
}

export const getTenantSubdomainFromHostname = (
	hostname: unknown,
	baseDomain: unknown,
	options?: {
		appSubdomain?: unknown
		reservedSubdomains?: unknown
	},
) => {
	const normalizedHost = normalizeHost(hostname)
	const normalizedBaseDomain = String(baseDomain || "")
		.trim()
		.toLowerCase()
	const reservedSubdomains = getReservedSubdomains(options)

	if (!normalizedHost) return null

	// Explicit custom-domain aliases
	const customTenant = CUSTOM_TENANT_HOSTS[normalizedHost]
	if (customTenant) {
		if (reservedSubdomains.includes(customTenant)) return null
		return customTenant
	}

	if (!normalizedBaseDomain) return null

	if (normalizedHost === normalizedBaseDomain) return null

	const suffix = `.${normalizedBaseDomain}`
	if (!normalizedHost.endsWith(suffix)) return null

	const labels = normalizedHost.slice(0, -suffix.length)
	if (!labels) return null

	const subdomain = labels.split(".")[0] || null
	if (!subdomain) return null
	if (reservedSubdomains.includes(subdomain)) return null

	return subdomain
}
